<template>
  <div class="text-center">
    <vueper-slides
      autoplay
      :fixed-height="true"
      class="no-shadow"
      :visible-slides="3"
      slide-multiple
      :arrows-outside="false"
      :bullets="false"
      :infinite="true"
      :dragging-distance="100"
      :touchable="true"
      :disable-arrows-on-edges="true"
      :breakpoints="{ 800: { visibleSlides: 1, } }"
    >
      <template #arrow-left>
        <img src="@/assets/images/icons/prev.png">
      </template>

      <template #arrow-right>
        <img src="@/assets/images/icons/next.png">
      </template>
      <vueper-slide
        v-for="(slide, i) in slides"
        :key="i"
        :image="slide.image"
      >
        <template #content>
          <div>
          </div>
        </template>
      </vueper-slide>
    </vueper-slides>
  </div>
</template>

<script>
import { VueperSlides, VueperSlide } from "vueperslides";
import "vueperslides/dist/vueperslides.css";

export default {
  name: "SliderProtests",
  data() {
    return {
      title: "Slider",
       slides: [
        {
          image: require("@/assets/images/slider_protest/1.jpg"),
  
        },
        {
          image: require("@/assets/images/slider_protest/2.jpg"),
        },
        {
          image: require("@/assets/images/slider_protest/3.jpg"),
        },
        {
          image: require("@/assets/images/slider_protest/4.jpg"),
        },
          {
          image: require("@/assets/images/slider_protest/5.jpg"),
  
        },
        {
          image: require("@/assets/images/slider_protest/6.jpg"),
        },
        {
          image: require("@/assets/images/slider_protest/7.jpg"),
        },
        {
          image: require("@/assets/images/slider_protest/8.jpg"),
        },
      ]
    };
  },
  components: { VueperSlides, VueperSlide },
};
</script>
